module.exports = __webpack_public_path__ + "img/教育考试院.0e852663.png";